module.exports = __webpack_public_path__ + "static/img/esp_8266-2.84de50a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/esp_8266-2.svg
// module id = +pA5
// module chunks = 0